export function openCity(evt, cityName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    jQuery(`.district`).removeClass(`active`);
    jQuery(`.${cityName}`).addClass(`active`);
    if(evt.currentTarget){
        evt.currentTarget.className += " active";
    }
    else{
        jQuery(evt.target).addClass('active') 
    }
    jQuery('.tablinks').attr('aria-pressed','false');
    jQuery(evt.target).attr('aria-pressed','true');
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?q='+cityName;
    window.history.pushState({path:newurl},'',newurl);
}

export function showroom_init(e) {
  jQuery('.showroom .show_tab').removeClass('actv');
  if(jQuery(e.target).hasClass('show_tab')){
    jQuery(e.target).addClass('actv');
  }
  else{
    jQuery(e.target).parents('.show_tab').addClass('actv');
  }
  
  //if(window.innerWidth > 992){
    let element = jQuery(e.target);
    if (element.parents('.wpcf7-form').length) return;
    
    e.preventDefault();
    if ( (!element.hasClass('mark_maps')) && element.parents('.mark_maps').length) {
        element = element.parents('.mark_maps');
    } else if(element.hasClass('tablinks')) {
        element = jQuery(jQuery('.district.active ul li')[0]);
    }
    var $lat = Number(element.attr('data-lat'));
    var $lng = Number(element.attr('data-lng'));
    var apikey = jQuery("#apikey").html();

    if($lat && $lng){
        $('#map-iframe iframe').attr('src','https://www.google.com/maps/embed/v1/place?key='+apikey+'&q='+$lat+','+$lng+'&language=fr&region=FR')
    }
    else{
        $('#map-iframe iframe').attr('src','https://www.google.com/maps/embed/v1/place?key='+apikey+'&q=France&language=fr&region=FR')
    }
    // var $icon = element.attr('data-icon');
    // var uluru = {
    //     lat: $lat,
    //     lng: $lng
    // };

    // var map = new google.maps.Map(document.getElementById('map'), {
    //     zoom: 16,
    //     center: uluru,
    //     mapTypeControl: true,

    //     fullscreenControl: true,
    //     fullscreenControlOptions: {
    //         position: google.maps.ControlPosition.LEFT_TOP
    //     },

    //     zoomControl: true,
    //     zoomControlOptions: {
    //         position: google.maps.ControlPosition.LEFT_BOTTOM
    //     },
    //     scaleControl: true,
    //     streetViewControl: true,
    //     streetViewControlOptions: {
    //         position: google.maps.ControlPosition.LEFT_BOTTOM
    //     },

    // });
    // var marker = new google.maps.Marker({
    //     position: uluru,
    //     map: map,
    //     icon: $icon
    // });
  //}

  if(window.innerWidth < 1200 ){
      setTimeout(function(){
        if($('.showroom.show-nearby .showroomsPopup').length >0){
            //console.log($('.showroom.show-nearby').css('display'));
            if($('.showroom.show-nearby').css('display')=='block'){
                //console.log('here');
                $('.strip').prependTo($('.showroom.show-nearby'));
            }
            else{
                //console.log(111);
            }
        }
      },100)
   
  }
  if(window.innerWidth < 993 ){
    if(!$('.showroom .tab').hasClass('slick-initialized')){
        $('.showroom .tab').slick({
            dots: false,
            arrows: false,
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 1281,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3
                }
            }],
        });
    }
  }
}

export function showroomEnableForm(event) {
    /*event.preventDefault();
    jQuery(".form-fade").fadeIn();
    jQuery(event.target).addClass('fade_out_btn');*/
}

export function scrollToElement(element) {
    var elementToScroll = "#"+element;
    if(elementToScroll.length) {
        $('.district').stop().animate({
            'scrollTop': $(elementToScroll).offset().top
        }, 1500);
    }
}
export function openFormPopup(event){
    event.preventDefault();
    var guid = $(event.target).parents('li.tabcontent').attr('data-guid');
    //$(event.target).parents('li.tabcontent').find('input[name="responsibilitycenter"]').val(guid);
    //$(event.target).parents('li.tabcontent').find('.showroomsPopup').addClass('open');

    $('.showroomsPopup').find('input[name="responsibilitycenter"]').val(guid);
    $('.showroomsPopup').addClass('open');

    $('body').addClass('showrooms-popup')
    if($(event.target).hasClass('hour_sticky'))
        if($(event.target).hasClass('close_hour'))
            $(event.target).parents('.show-nearby').find('.showroomsPopup').addClass('open');
    if(window.innerWidth > 767){
        setTimeout(function(){ 
            $(".form_popup_close.desktop").focus();
            $('.submit-btn .wpcf7-submit').on('keydown', function (e) {
                if ((e.which === 9 && !e.shiftKey)) {
                    e.preventDefault();
                    $('.form_popup_close.desktop').focus();
                }
            });
            $('.close').on('keydown', function (e) {
                if ((e.which === 9 && e.shiftKey)) {
                    e.preventDefault();
                    $('.submit-btn .wpcf7-submit').focus();
                }
            });
        },100);
    }
    else{
        setTimeout(function(){ 
            $(".form_popup_close.mobile").focus();
        },100);
    }

}
export function clodePoppup(){
    $('.showroomsPopup').removeClass('open');
    $('body').removeClass('showrooms-popup')
}
export function openFormPopupKeyPressed(event){
    var keyCode = event.keyCode || event.which; 
    if(keyCode == 13){
        openFormPopup(event);
    }
}
export function closePoppupKeyPressed(event){
    var keyCode = event.keyCode || event.which; 
    if(keyCode == 13){
        clodePoppup();
    }
}
export function changeUrl(e){
  if(jQuery(e.target).hasClass('tabcontent') || jQuery(e.target).parents('.tabcontent').length != -1){
    let q = jQuery(e.target).parents('.district').attr('id').replace('district_','') + '/' + (jQuery(e.target).attr('data-name') ? jQuery(e.target).attr('data-name') : jQuery(e.target).parents('.tabcontent').attr('data-name'))
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?q='+q;
    window.history.pushState({path:newurl},'',newurl);
  }
}

export function getUrlParams( sParam ) {
    const sPageURL = decodeURIComponent(
            window.location.search.substring( 1 )
        ),
        sURLVariables = sPageURL.split( '&' );
    let sParameterName, i;

    for ( i = 0; i < sURLVariables.length; i++ ) {
        sParameterName = sURLVariables[ i ].split( '=' );

        if ( sParameterName[ 0 ] === sParam ) {
            return sParameterName[ 1 ] === undefined
                ? true
                : sParameterName[ 1 ];
        }
    }
}
export function mobileOpenMap(event) {
    //console.log($(event.target).attr('class'))
    $('.showroom_desk .map-wrap .details .left-side .title').html($(event.target).parents('li').find('.title h3').html());
    $('.showroom_desk .map-wrap .details .left-side .address_adress').html($(event.target).parents('li').find('.address_adress').html());
    $('.showroom_desk .map-wrap .details .left-side .close_open').html($(event.target).parents('li').find('.hour_sticky span').html()+'<span class="point"></span>'+$(event.target).parents('li').find('.distance').html());
    $('.showroom_desk .navigation-app .waze-link').html('<a target="_blank" href="https://waze.com/ul?ll='+$(event.target).parents('li').attr('data-lat')+','+$(event.target).parents('li').attr('data-lng')+'">Waze</a>')
    if( (navigator.platform.indexOf("iPhone") != -1) 
        || (navigator.platform.indexOf("iPod") != -1)
        || (navigator.platform.indexOf("iPad") != -1)){
         $('.showroom_desk .navigation-app .gmap-link').html('<a target="_blank" href="maps://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination='+$(event.target).parents('li').attr('data-lat')+','+$(event.target).parents('li').attr('data-lng')+'">Google Maps</a>')
         //window.open("maps://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=[YOUR_LAT],[YOUR_LNG]");
    }
    else{
        $('.showroom_desk .navigation-app .gmap-link').html('<a target="_blank" href="https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination='+$(event.target).parents('li').attr('data-lat')+','+$(event.target).parents('li').attr('data-lng')+'">Google Maps</a>')
        //window.open("https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=[YOUR_LAT],[YOUR_LNG]");
    }
    $('.showroom_desk .map-wrap').show();
    setTimeout(function(){
        $('.showroom_desk .map-wrap .close').focus();
    },100)
}
export function mobileCloseMap() {
    $('.showroom_desk .map-wrap').hide();
}

export function mobileOpenNavigation() {
    $('.showroom_desk .navigation-app').show();
}
export function mobileCloseNavigation() {
    $('.showroom_desk .navigation-app').hide();
}
